/**
 * WebSocket client service.
 */

const websocket = require('ws');

import Const from '../../../constants';

const log = (global as any).log;

class WsClientService {
    static ws: any;

    /**
     * Init WebSocket client.
     */
    static initWebSocket(url) {
        log.debug(`> Kernel.WsClientService.initWebSocket() URL: ${url}`);

        let webContents = global.mainWindow.webContents;

        // Open WebSocket connection.
        let ws = new websocket(url);

        ws.on('open', () => {
            webContents.send('cen-ws-event', {name: 'open'});
        });

        ws.on('close', () => {
            webContents.send('cen-ws-event', {name: 'close'});
        });

        ws.on('error', () => {
            webContents.send('cen-ws-event', {name: 'error'});
        });

        ws.on('message', data => {
            webContents.send('cen-ws-event', {name: 'message', data: data});
        });

        WsClientService.ws = ws;

        return Promise.resolve();
    }

    /**
     * Check if WebSocket client is connected.
     */
    static isWsClientConnected() {
        return (WsClientService.ws !== null) && (WsClientService.ws.readyState === Const.WsReadyState.OPEN);
    }

    /**
     * Send message.
     */
    static sendWsMessage(message) {
        log.debug(`> Kernel.WsClientService.sendWsMessage()`);

        return new Promise<void>((resolve, reject) => {
            WsClientService.ws.send(message, () => {
                resolve();
            });
        });
    }
}

WsClientService.ws = null;

export default WsClientService;
